import Typography from '@material-ui/core/Typography';
import LinkComp from 'components/atoms/LinkComp';
import ProductLimitMessage from 'components/mocules/ProductLimitMessage';
import TagComponent from 'components/mocules/TagComponent';
import { COLOR_STORE } from 'constants/Icons';
import { SVGPrice } from 'constants/SVG';
import { useConfigHangDiem } from 'hooks/useConfigHangDiem';
import { forwardRef } from 'react';
import { getSellerData } from 'services/SellerService';
import { DOMAIN_WEB_HOST } from 'sysconfig';
import { ImageFallbackProductImage, ImageFallbackStatic } from 'utils/ImageFallback';
import { getMedicineTypeLabels } from 'utils/ProductLabelUtils';
import styles from './styles.module.css';
import QuantityControlTable from '../QuantityControlTable';

function ProductItemDeal({ product, tags, statusData, expiredDate, imgUrl, link }) {
  const { sellerName } = getSellerData({ seller: product.sellerInfo, tags });
  const { isHangDiem, iconHangDiem, linkRedirect } = useConfigHangDiem({ vendorInfoSellerCode: product?.vendorInfo?.sellerCode });

  // Nhãn phân loại thuốc (kê đơn / không kê đơn / thiết yếu / kiểm soát đặc biệt)
  const medicineTypeLabels = getMedicineTypeLabels(product);

  return (
    <div className={styles.wrapperDeal}>
      <div className={styles.itemDeal}>
        <div className={styles.groupInfoDealTop}>
          <LinkComp className={styles.image} href={`${DOMAIN_WEB_HOST}/product/${product?.slug || ''}`} padding="0px">
            <ImageFallbackProductImage size="thumbnail" width={112} height={112} src={imgUrl} quality={100} objectFit="contain" />
          </LinkComp>
          <div className={styles.nameTag}>
            <LinkComp
              href={`/seller-products/${product?.sellerInfo?.code || product?.sellerInfo?.sellerCode}/${product?.sellerInfo?.sellerType == 'ENTERPRISE' ? product?.sellerInfo?.slug : ''}`}
              padding="0px"
            >
              {sellerName === 'MEDX' && (
                <ImageFallbackStatic width="12" height="12" src={COLOR_STORE} alt="thuocsi store" className={styles.image_logo} />
              )}
              <span className={styles.score}>{sellerName}</span>
            </LinkComp>
            <LinkComp href={`${DOMAIN_WEB_HOST}/product/${product?.slug || ''}`} padding="0px">
              <Typography className={styles.nameXs}>{product?.name}</Typography>
            </LinkComp>
            <div className={styles.hightLightTag}>
              {medicineTypeLabels.length > 0 && (
                <div className={styles.medicineType}>
                  {medicineTypeLabels.map((info) => (
                    <ImageFallbackStatic
                      key={info.variant}
                      src={info.icon.src}
                      height={20}
                      width={Math.round((info.icon.width / info.icon.height) * 20)}
                      alt={info.label}
                    />
                  ))}
                </div>
              )}
              <TagComponent
                product={{ tags, statusData, expiredDate, isHangDiemStore: isHangDiem, iconHangDiem }}
                isMobile
                isSellerList={false}
                isPageDetail
                link={isHangDiem ? linkRedirect : link}
              />
            </div>
            <span className={styles.volume}>{product?.volume}</span>
          </div>
        </div>
        <div className={styles.groupQuantity}>
          {product.retalPriceDifferencePrice && (
            <Typography className={styles.amountSaved}>
              Rẻ hơn {product.retalPriceDifferencePrice}
              <br />
              trên mỗi sản phẩm
            </Typography>
          )}
          <div className={styles.groupInfoDeal}>
            <Typography className={styles.price}>
              <SVGPrice displayPriceFormated={product?.displayPriceFormated || 0} fillPath="black" size="md" />
            </Typography>
            {/* {product?.discountPercent ? <span className={styles.originalPrice}>{product?.salePriceFormated || 0}</span> : null} */}
          </div>
        </div>
        <div className={styles.flexContainer}>
          <QuantityControlTable product={product} className={styles.quantityControlWithDeal} />
          <ProductLimitMessage consumedMaxQuantity={product.consumedMaxQuantity} unit={product.unit} page="product" />
        </div>
      </div>
      <div className={styles.topPosition}>
        {product?.discountPercent > 0 && <span className={styles.discountDeal}> -{product?.discountPercent}%</span>}
      </div>
    </div>
  );
}

const BuyWithDeal = forwardRef(({ products, link }, ref) => (
  <>
    {products?.length > 0 ? (
      <div className={styles.buyWithDeal} ref={ref}>
        <Typography className={styles.title}>Mua kèm deal sốc</Typography>
        {products.map((item) => (
          <ProductItemDeal
            key={item.productId}
            product={item}
            tags={item?.tags}
            imgUrl={item?.imagesProxy[0]}
            statusData={item?.statusData}
            expiredDate={item?.expiredDate}
            link={link}
          />
        ))}
      </div>
    ) : null}
  </>
));

BuyWithDeal.displayName = 'BuyWithDeal';

export default BuyWithDeal;
